export default __webpack_public_path__ + "static/erling-001fdd956ca56bd60bd83f503605f19f.jpg";